import React from 'react';

import { JsonLd } from 'react-schemaorg';
import { Organization } from 'schema-dts';

/**
 * Renders the JSON-LD For Organization
 */
export function OrganizationJsonLd() {
  return (
    <JsonLd<Organization>
      item={{
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: Config.Web.Links.NAKED_WEB_URL,
        logo: Config.Web.Links.NAKED_WEB_LOGO,
        name: 'Naked Insurance',
        sameAs: [
          Config.Shared.Links.SocialMedia.INSTAGRAM_URL,
          Config.Shared.Links.SocialMedia.FACEBOOK_URL,
          Config.Shared.Links.SocialMedia.TWITTER_URL,
          Config.Shared.Links.SocialMedia.LINKEDIN_URL,
        ],
        contactPoint: [
          {
            '@type': 'ContactPoint',
            areaServed: 'ZA',
            contactType: 'technical support',
            telephone: '+27860 995 125',
          },
        ],
      }}
    />
  );
}
